const initialState = {
  phoneInfo: '',
};

// 收货地址
export default function receiveAddressDate(state = initialState, action) {
  switch (action.type) {
  case 'GET_PHONE':
    return { ...state, phoneInfo: action.payload };
  default:
    return state;
  }
}